import React from "react";
import PropTypes from 'prop-types';

export const ArrowRight = ({ color, width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 29 11"
    >
      <g fill="none" stroke={color}>
        <path strokeLinecap="square" d="M28 5.5H1.469"></path>
        <path strokeLinecap="round" d="M23 0l5.5 5.5L23 11"></path>
      </g>
    </svg>
  );
}

ArrowRight.defaultProps = {
  color: '#d2d2d2',
  width: '29',
  height: '11'
}

ArrowRight.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
}
